import { FC, useState } from 'react'

import React from 'react'
import SfLink from '@ui/components/next/SfLink'
import css from 'styled-jsx/css'

type OrderNotFoundProps = {
  className?: string
}

const OrderNotFound: FC<OrderNotFoundProps> = ({ className }) => {
  const [loading, setLoading] = useState<boolean>(false)

  return (
    <>
      <style jsx>{OrderNotFoundStyle}</style>
      <div className={`order-not-found ${className}`}>
        <div className="content">
          <div className="subtitle">No order found or this item was purchased!</div>
          <SfLink
            pathName="/"
            className={`button is-large is-primary${loading ? 'is-loading' : ''}`}
          >
            <span onClick={() => setLoading(true)}>Continue shopping</span>
          </SfLink>
        </div>
      </div>
    </>
  )
}

export default OrderNotFound

const OrderNotFoundStyle = css`
  .order-not-found {
    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      padding: 20px;
      text-align: center;
    }
  }
`
